import { Injectable, inject } from '@angular/core';
import {
  Firestore,
  collection,
  query,
  where,
  getDocs,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  Timestamp,
} from '@angular/fire/firestore';
import { SongComment } from '../entities/comment.model';

@Injectable({ providedIn: 'root' })
export class CommentService {
  private firestore = inject(Firestore);

  async getComments(songId: string): Promise<SongComment[]> {
    const snap = await getDocs(
      query(collection(this.firestore, 'song_comments'), where('songId', '==', songId))
    );
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() } as SongComment))
      .sort((a, b) => a.createdAt.toMillis() - b.createdAt.toMillis());
  }

  async addComment(songId: string, uid: string, displayName: string, text: string): Promise<void> {
    await addDoc(collection(this.firestore, 'song_comments'), {
      songId,
      uid,
      displayName,
      text: text.trim(),
      createdAt: Timestamp.now(),
    });
  }

  async updateComment(commentId: string, text: string): Promise<void> {
    await updateDoc(doc(this.firestore, 'song_comments', commentId), { text: text.trim() });
  }

  async deleteComment(commentId: string): Promise<void> {
    await deleteDoc(doc(this.firestore, 'song_comments', commentId));
  }
}
